<script lang="ts">
    export let value: string;
    export let size: string = 'xs';
</script>
{#if value === 'requested'}
    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-yellow-100 px-2 py-1 text-{size} font-medium text-yellow-800">
      <svg class="h-1.5 w-1.5 fill-yellow-500" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      Anfrage
    </span>
{:else if value === 'confirmed'}
    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-green-100 px-2 py-1 text-{size} font-medium text-green-800">
      <svg class="h-1.5 w-1.5 fill-green-500" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      Auftrag
    </span>
{:else if value === 'finished'}
    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-coolGray-100 px-2 py-1 text-{size} font-medium text-coolGray-800">
      <svg class="h-1.5 w-1.5 fill-coolGray-500" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      Stunden gebucht
    </span>
{:else if value === 'billing'}
    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-100 px-2 py-1 text-{size} font-medium text-indigo-800">
      <svg class="h-1.5 w-1.5 fill-indigo-500" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      Rechnung geschrieben
    </span>
{:else if value === 'canceled'}
    <span class="inline-flex items-center gap-x-1.5 rounded-md bg-red-100 px-2 py-1 text-{size} font-medium text-red-800">
      <svg class="h-1.5 w-1.5 fill-red-500" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      Storniert
    </span>
{/if}